import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { z } from 'zod';
import SUBMIT_ACCESS_CODES from 'src/graphql/mutation/submit-access-code-mutiple.graphql';

const useAccessCodesEffect = (
  accessCodes: AccessCodesSchemaType['accessCodes'],
  onCompleted?: () => void
) => {
  const [submitAccessCodes, result] = useMutation(SUBMIT_ACCESS_CODES, {
    onCompleted,
  });

  useEffect(() => {
    const abortController = new AbortController();

    const callback = async (codes: AccessCodesSchemaType['accessCodes']) =>
      submitAccessCodes({
        variables: { accessCodes: codes },
        context: {
          fetchOptions: { signal: abortController.signal },
        },
      });

    // Apollo error link handles errors; suppress rejection to avoid Sentry duplicate via onunhandledrejection
    if (accessCodes && accessCodes.length > 0)
      callback(accessCodes).catch(() => {});

    return () => abortController.abort();
  }, [accessCodes, submitAccessCodes]);

  return result;
};

export const AccessCodesSchema = z.object({
  accessCodes: z.array(z.string()).optional(),
});

type AccessCodesSchemaType = z.infer<typeof AccessCodesSchema>;

export default useAccessCodesEffect;
